export enum EnumBillingQueryKeys {
  BILLING_OFFERS = 'BILLING_OFFERS',
  PAYMENT_SERVICE_PROVIDER_CUSTOMER = 'PAYMENT_SERVICE_PROVIDER_CUSTOMER',
  USER_SEPA_DETAILS = 'USER_SEPA_DETAILS',
}
